<template>
  <div class="navbar">
    <el-row>
      <div class="navbar-logo">
        <span class="logo">
          <img src="@/assets/img/logo.png" class="img-responsive" />
        </span>
      </div>
      <div style="flex:1;-webkit-box-flex: 1;text-align:center;display: inline-flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;">
        <el-menu :default-active="activeIndex" class="el-menu-demo header-menu" mode="horizontal" @select="handleSelect">
          <el-menu-item v-for="item in menuItemList" :key="item.name" :index='item.index'>
            <span>{{item.name}}</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div style="float:right; min-width:50px" class="navbar-user">
        <div class="right-menu-item" style="padding-right:50px">
          <div class="icon" style="margin-top:19px; line-height: 26px;">
            <div style="text-align:right;float:right;" @click="logout">
              <el-tooltip :content="$t('sign_out')" placement="top" effect="light">
                <span class="logout"><i class="icon-16 icon-color common-icon icon-signout"></i></span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div style="float:right; min-width:120px" class="navbar-user" id="userInfo">
        <div class="right-menu-item">
          <div class="name" style="cursor: pointer;" @click="getUserInfo">
            <el-tooltip :content="userName" placement="top" effect="light">
            <span>{{$t(userName)}}</span>
            </el-tooltip>
            <!-- <div class="position" style="">position</div> -->
          </div>
        </div>
        <!-- <div class="right-menu-item"><img src="#" class="userIcon"></div> -->
        <el-dialog :visible.sync="dialogVisible" @close="getUser" @open="getUser" width="80%" custom-class="dialog-class" :close-on-click-modal="false" destroy-on-close>
          <div slot="title" class="dialog-title">
            {{'Modify User Information'}}
          </div>
          <formPage v-if="dialogVisible" @closeAction="dialogVisibleVal" :rowVal="rowVal" ref="formPage" />
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" round @click="handleOkClick" style="width: 200px;" size="mini">{{ $t('submit') }}</el-button>
            <el-button type="default" round @click="handleCancelClick" style="width: 200px;" size="mini">{{ $t('cancel') }}</el-button>
          </span>
        </el-dialog>
      </div>
    </el-row>
  </div>
</template>
<script>
import authInfoMgmt from '@/auth-info-mgmt-inst';
import formPage from './formPage/formPage';
import userApi from '@/apis/user';
export default {
  name: 'Navbar',

  data() {
    return {
      userName: '',
      dialogVisible: false,
      rowVal: {},
      menuItemList: [
        {
          name: this.$t('product_list'),
          index: '/productList/index'
        },
        {
          name: this.$t('order_list'),
          index: '/orderList/index'
        },
        {
          name: this.$t('erp_list'),
          index: '/erpList/index'
        }
      ]
    };
  },

  mounted() {
    // const that = this;
    // that.userName = authInfoMgmt.getAuthInfo().nickname;
    this.getUser();
  },

  computed: {
    activeIndex() {
      return this.$route.path;
    }
  },

  methods: {
    async getUser() {
      const req = {};
      const res = await userApi.getUserInfo(req);
      this.rowVal = { ...res };
      this.userName =
        this.rowVal.firstName +
        '\xa0' +
        this.rowVal.lastName;
    },

    handleSelect(key) {
      if (key === this.activeIndex) {
        return;
      }
      this.$router.push({
        path: key
      });
    },

    logout() {
      // 返回登陆
      authInfoMgmt.signOut();
      window.location = '/';
    },

    getUserInfo() {
      this.dialogVisible = true;
    },

    handleCancelClick() {
      this.dialogVisible = false;
    },

    dialogVisibleVal(val) {
      this.dialogVisible = val;
    },

    handleOkClick() {
      this.$refs.formPage.Submit();
    }
  },

  components: {
    formPage
  }
};
</script>
<style scoped lang="scss">
$navHeight: 80px;

@mixin nav-height {
  height: $navHeight;
  line-height: $navHeight;
  display: inline-block;
}

.navbar {
  height: $navHeight;
  border-bottom: solid 1px #e6e6e6;
  position: absolute;
  top: 0;
  width: 100%;
  min-width: 1366px;

  &-logo {
    @include nav-height;
  }

  &-user {
    @include nav-height;
  }
}

.navbar-logo {
  width: 223px;
  float: left;
  display: flex;
  text-align: left;
  .logo {
    max-width: 220px;
    max-height: 80px;
    .img-responsive {
      display: inline-block;
      // height: auto;
      margin: 10px 10px 10px 30px;
      width: 200px;
      height: 60px;
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.userIcon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 15px;
}

.el-menu-demo {
  margin: 0 auto;
}

.right-menu-item {
  width: max-content;
  float: right;
  .name {
    width: 100px;
    color: #292929;
    font-weight: bold;
    font-size: 20px;
    line-height: 77px;
    letter-spacing: 0.1px;
    // margin-left: 10px;
    // margin-top: 19px;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .position {
      color: #c7c8c9;
      font-weight: regular;
      font-size: 12px;
      line-height: 12px;
      letter-spacing: 0.1px;
      text-align: right;
      width: max-content;
      margin-top: 6px;
    }
  }
  .icon {
    color: #c7c8c9;
    font-weight: regular;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.1px;
    text-align: left;
    margin-left: 10px;
    margin-top: 3px;
    width: 100% !important;
    vertical-align: top !important;
    .logout {
      cursor: pointer;
      // background: url('../../assets/img/icon_sign-out.png') no-repeat center
      //   center;
      // background-size: 100% 100%;
      display: block;
    }
    .logout:hover,
    .logout:focus,
    .logout:active {
      cursor: pointer;
      // background: url('../../assets/img/icon_sign-out_pass.png') no-repeat
      //   center center;
      // background-size: 100% 100%;
      display: block;
    }
  }
}

.common-icon {
  font-size: 24px;
  margin-left: -15px;
}
</style>

<style lang="scss">
.dialog-class {
  border-radius: 14px !important;
  .el-dialog__header {
    background-color: #f4f4f4;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
    padding: 50px 0 31px 50px;
  }

  .el-dialog__body {
    max-height: 50vh;
    overflow: auto;
    padding: 40px 165px 0;
  }

  .el-dialog__footer {
    padding-top: 20px;
    background: #f4f4f4;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
    text-align: center;
  }
}

.el-tooltip__popper {
  color: #000 !important;
  max-width: 50%;
  background: #FFF !important;
  border: 1px  solid #000 !important;
  line-height: 1 !important;
  margin-bottom: 0px !important;
}
.el-tooltip__popper .popper__arrow:after {
  border-top-color: #FFF !important;
}
</style>